import {
  BarChartOutlined,
  CalendarOutlined,
  CoffeeOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  FileDoneOutlined,
  NotificationOutlined,
  PhoneOutlined,
  PictureOutlined,
  ProfileOutlined,
  QuestionCircleOutlined,
  RobotOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  SolutionOutlined,
  StarOutlined,
  TeamOutlined,
  ToolOutlined,
  TrophyOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { type ReactNode } from "react";

import { type DashboardPermissionArea } from "./dashboardPermissionRequirements";

export interface DashboardNavigationItem {
  disabled?: boolean;
  icon: ReactNode;
  inMenu: boolean;
  label: string;
  matchPaths?: readonly string[];
  name: DashboardPermissionArea | "dashboard";
  path: string;
}

const menuIconStyle = { fontSize: 18 };

export const dashboardNavigation: readonly DashboardNavigationItem[] = [
  {
    name: "dashboard",
    path: "/dashboard",
    icon: <DashboardOutlined style={menuIconStyle} />,
    label: "menu.dashboard",
    inMenu: true,
  },
  {
    name: "products",
    path: "/products",
    icon: <ShoppingCartOutlined style={menuIconStyle} />,
    label: "menu.products",
    inMenu: true,
  },
  {
    name: "sales",
    path: "/sales",
    icon: <PhoneOutlined style={menuIconStyle} />,
    label: "Sales CRM",
    inMenu: true,
  },
  {
    name: "marketing",
    path: "/marketing",
    icon: <BarChartOutlined style={menuIconStyle} />,
    label: "marketingAnalytics.menu",
    inMenu: true,
  },
  {
    name: "studio",
    path: "/studio",
    icon: <VideoCameraOutlined style={menuIconStyle} />,
    label: "Studio",
    inMenu: true,
  },
  {
    name: "support",
    path: "/support",
    icon: <CustomerServiceOutlined style={menuIconStyle} />,
    label: "Zgłoszenia",
    inMenu: true,
  },
  {
    name: "traineeList",
    path: "/trainee",
    icon: <StarOutlined />,
    label: "menu.trainee",
    inMenu: true,
  },
  {
    name: "calendar",
    path: "/calendar",
    icon: <CalendarOutlined style={menuIconStyle} />,
    label: "Kalendarz",
    inMenu: true,
  },
  {
    name: "engagement",
    path: "/challenges",
    matchPaths: ["/challenges", "/habits", "/badges"],
    icon: <TrophyOutlined style={menuIconStyle} />,
    label: "Zaangażowanie",
    inMenu: true,
  },
  {
    name: "programs",
    path: "/programs",
    icon: <SolutionOutlined style={menuIconStyle} />,
    label: "menu.programs",
    inMenu: true,
  },
  {
    name: "nutrition",
    path: "/nutrition",
    icon: <CoffeeOutlined style={menuIconStyle} />,
    label: "menu.nutrition",
    inMenu: true,
  },
  {
    name: "surveys",
    path: "/surveys",
    icon: <FileDoneOutlined style={menuIconStyle} />,
    label: "menu.surveys",
    inMenu: true,
  },
  {
    name: "campaigns",
    path: "/campaigns",
    icon: <NotificationOutlined style={menuIconStyle} />,
    label: "menu.campaigns",
    inMenu: true,
  },
  {
    name: "landings",
    path: "/landings",
    icon: <PictureOutlined style={menuIconStyle} />,
    label: "Landingi",
    inMenu: true,
  },
  {
    name: "team",
    path: "/team",
    icon: <TeamOutlined style={menuIconStyle} />,
    label: "menu.team",
    inMenu: true,
  },
  // Rozliczenia i Statystyki nie mają własnych pozycji w sidebarze — to taby
  // wewnątrz /team (TeamArea), ograniczane per uprawnienie; menu "Zespół"
  // pokazuje się, gdy przysługuje którykolwiek tab (requirement teamArea).
  {
    name: "ai",
    path: "/ai",
    icon: <RobotOutlined style={menuIconStyle} />,
    label: "menu.ai",
    inMenu: true,
  },
  {
    name: "helpCenter",
    path: "/help-center",
    icon: <QuestionCircleOutlined style={menuIconStyle} />,
    label: "Centrum pomocy",
    inMenu: true,
  },
  {
    name: "appConfig",
    path: "/app-config",
    icon: <SettingOutlined style={menuIconStyle} />,
    label: "menu.appConfig",
    inMenu: true,
  },
  {
    name: "automation",
    path: "/automation",
    icon: <ToolOutlined style={menuIconStyle} />,
    label: "menu.automation",
    inMenu: true,
  },
  {
    name: "chat",
    path: "/chat",
    icon: <ProfileOutlined />,
    label: "menu.profile",
    inMenu: false,
  },
];
